import React, { useState } from 'react'
import googleDocs from "../Assets/images/google-docs.svg"
import excelImg from "../Assets/images/excel.svg"
import { useNavigate } from 'react-router-dom'
import { LanguageConstants } from '../constants/LanguageConstants'



function RequestQuoteModal(prop:any) {
    const [type , setType] = useState('')
    const [error , setError] = useState('')
    const navigate = useNavigate()

  const handleSelect =()=>{
    if(!type){
       setError(LanguageConstants?.PLEASE_SELECT_TYPE) 
    }else{
        navigate(`/${type}`)
        setError('')
        prop.handelClso()
    }
  }  
   
  return (
    <>
     <div className="modal fade com-modal rqst-quote-modal show" id="requestQuoteModal" aria-labelledby="requestQuoteModalLabel" aria-hidden="true" style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header justify-content-center" >
                            <h5 className="modal-title text-center w-100 text-center" id="requestQuoteModalLabel"  >{LanguageConstants?.NEW_REQUEST_QUOTES}</h5>
                            {/* <h5 className="modal-title" id="requestQuoteModalLabel"></h5> */}
                            <button type="button" onClick={()=> prop.handelClso()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                            <p  style={{fontSize:'large' , textAlign:'center'}} >{LanguageConstants?.SELECT_METHOD}</p>
                        <div className="modal-body pb-0 text-start">
                            <div className="row gy-4 pt-4">
                                <div className=" col-sm-6">
                                    <div className="rqst-btn-btn form-check" onClick={()=>setType('create-request-quote')} >
                                            <input className="form-check-input form-check-radio" type="radio" name="requestQuote" id="requestQuote-1" />
                                        <label htmlFor="requestQuote-1">
                                            <img src={googleDocs} alt="" />
                                            <span>{LanguageConstants?.QUOTATIONFORM}</span>
                                        </label>
                                    </div>
                                </div>
                                <div className=" col-sm-6">
                                    <div className="rqst-btn-btn form-check" onClick={()=>setType('select-excel-address')} >
                                            <input className="form-check-input form-check-radio" type="radio" name="requestQuote" id="requestQuote-2"  />
                                        <label htmlFor="requestQuote-2">
                                            <img src={excelImg} alt="" />
                                            <span>{LanguageConstants?.EXCEL}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        <p className='text-error-new'>{error}</p>
                                                      
                        </div>
                        <div className="modal-footer mt-4 mt-md-0">
                            <button type="submit" className="round-btn m-0" onClick={()=>handleSelect()}  >{LanguageConstants?.COUNTINUE}</button>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default RequestQuoteModal